// import { COUNTRY_DIAL_CODES } from '@/utils/countryDialCodes';
import type { FormState, UserTypeConfig } from '@/shared/types/users.types';
import type { ColorHelpers } from '@/utils/colorHelpers';
import PhoneInput from '@/components/common/PhoneInput';

interface Props {
    form: FormState;
    set: <K extends keyof FormState>(k: K, v: FormState[K]) => void;
    config: UserTypeConfig;
    c: ColorHelpers;
}

const INPUT = 'w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:border-transparent';

export function StepContact({ form, set, config, c }: Props) {
    return (
        <div className="space-y-5">
            <h2 className="text-xl font-semibold text-gray-900">Vos informations de contact</h2>

            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Prénom <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={form.firstName}
                        onChange={e => set('firstName', e.target.value)}
                        placeholder="Votre prénom"
                        className={`${INPUT} ${c.ring}`}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Nom <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={form.lastName}
                        onChange={e => set('lastName', e.target.value)}
                        placeholder="Votre nom de famille"
                        className={`${INPUT} ${c.ring}`}
                    />
                </div>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Téléphone <span className="text-red-500">*</span>
                    <span className="text-gray-400 text-xs ml-2">(utilisable pour se connecter)</span>
                </label>
                <div className="flex gap-2">
                    {/* Intégration du PhoneInput générique */}
                    <PhoneInput
                        countryCode={form.phoneCountryCode}
                        phone={form.phone}
                        onCountryCodeChange={v => set('phoneCountryCode', v)}
                        onPhoneChange={v => set('phone', v)}
                        placeholder="620 00 00 00"
                        disabled={false}
                        error={!!(form.phone && !/^\d{6,15}$/.test(form.phone))}
                    />
                    {/* <input
                        type="tel"
                        value={form.phone}
                        onChange={e => set('phone', e.target.value.replace(/\D/g, ''))}
                        placeholder="620 00 00 00"
                        className={`flex-1 ${INPUT} ${c.ring}`}
                    /> */}
                </div>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Adresse e-mail
                    {config.emailRequired
                        ? <span className="text-red-500 ml-1">*</span>
                        : <span className="text-gray-400 text-xs ml-2">(optionnelle)</span>
                    }
                </label>
                <input
                    type="email"
                    value={form.email}
                    onChange={e => set('email', e.target.value)}
                    placeholder="vous@exemple.com"
                    className={`${INPUT} ${c.ring}`}
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Mot de passe <span className="text-red-500">*</span>
                </label>
                <input
                    type="password"
                    value={form.password}
                    onChange={e => set('password', e.target.value)}
                    placeholder="Minimum 8 caractères"
                    className={`${INPUT} ${c.ring}`}
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Confirmer le mot de passe <span className="text-red-500">*</span>
                </label>
                <input
                    type="password"
                    value={form.confirmPassword}
                    onChange={e => set('confirmPassword', e.target.value)}
                    placeholder="Répétez le mot de passe"
                    className={`${INPUT} ${c.ring} ${form.confirmPassword && form.confirmPassword !== form.password
                        ? 'border-red-400'
                        : ''
                        }`}
                />
                {form.confirmPassword && form.confirmPassword !== form.password && (
                    <p className="text-red-500 text-xs mt-1">Les mots de passe ne correspondent pas.</p>
                )}
            </div>
        </div>
    );
}
